import { connect } from 'react-redux';

import FilterCheckboxComponent
  from '../Components/FilterCheckboxComponent';
import { changeArtifactHealthFilter } from './../actions';
import { getArtifactHealthFilters } from './../reducers';
import { artifactHealth } from './../helpers';

export const mapStateToProps = state => {
  return {
    filters: [...artifactHealth.ARTIFACT_HEALTH_STATUSES.map(s => s.name),
      ...artifactHealth.ARTIFACT_HEALTH_TIERS],
    currentFilters: getArtifactHealthFilters(state)
  };
};

export default connect(
  mapStateToProps,
  { onFilterChange: changeArtifactHealthFilter }
)(FilterCheckboxComponent);


// WEBPACK FOOTER //
// src/Containers/ArtifactHealthFilterContainer.jsx